export default __webpack_public_path__ + "static/media/Custom-Decoration-Items-Steel-Metal-Sheet-Metal-Fabrication-Enclosures-Product-SMP112201-.97802ff8.webp";